export default __webpack_public_path__ + "static/media/PartnerTools.b5d5bd21.svg";